module.exports = __webpack_public_path__ + "img/ppt.ed55bacf.svg";